module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAyCAYAAABPq7vSAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPlJREFUeNrc2NkNgzAQRVE/KqCUtJBGslSWpYGUkBZSCiVkkPKBEIuXmfsRSxab0UGA7fGk9CuX8+lltU/BpZvsD1bf0aimB4bdbHOwerw/nkM4SKBaOhmJau1CFKqtixGo9hp4o8pp5Ikqt6EXqpLGHqhKb2hFVfOULahqv0UtqpY/rgZVa78qReUxepSgLmAJ6gbmoq5gDuoO7qEh4BYaBq6hoeAS2kWDhlxt8xlD0HlcipSOfKX/9dOg3QLt+OjQhg7e6PSETsBoiIEGUWiYiAbCaKiPLmbQ5Rq6IEWX3GhSAU2boIkhNPWFJvcIbB4m9tHYWL4CDAA2HuswFqj1HwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/arrow-right.png
// module id = tzqg
// module chunks = 1